import React from "react";
import { Navigate, Route, Routes,Outlet } from "react-router-dom";
import { LoaderProvider } from "../common/component/LoaderProvider";
import {useSelector } from "react-redux";

const PublicRoute = ({children, isAuthenticated}) => {
    const userLogged = JSON.parse(localStorage.getItem("token"));
    const userId=JSON.parse(localStorage.getItem("userId"));
    const isSuccess=JSON.parse(localStorage.getItem('isSuccess'));
    const roleId=localStorage.getItem('roleId');
    const resetPwdValue=useSelector((state)=>state.commonReducer.resetPwd)
    // 
    return userLogged && isSuccess ==true && !resetPwdValue
      ? 
      <Navigate to="/dashboard"  /> :
     
    
      <LoaderProvider>
      <Outlet />
      </LoaderProvider>

};

export default PublicRoute;

// resetpwd is always false when clicking the reset pwsed at that time forcely changing the route as /login it should not to move.
// isSuccess is handled when both firstaccess and tempswd true then it should go to the change pswd without the dashboard screen.